export const DEMO_MUTATION = 'DEMO_MUTATION'
export const UPDATE_LOGIN_STATE = 'UPDATE_LOGIN_STATE'
export const UPDATE_PAY_STATE = 'UPDATE_PAY_STATE'
export const CAN_BUY = 'CAN_BUY'
export const TRADE_STATUS = 'TRADE_STATUS'
export const ADDHISTORYLENGTH = 'ADDHISTORYLENGTH'
export const MINUSHISTORYLENGTH = 'MINUSHISTORYLENGTH'
export const INITHISTORYLENGTH = 'INITHISTORYLENGTH'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js